import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VCharts from "v-charts";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "font-awesome/css/font-awesome.min.css";

// 引入xlsx
import XLSX from 'xlsx';
Vue.use(XLSX)
// 引入echarts图表框架
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.use(Element);
Vue.use(VCharts);

import axios from "axios";
import VueAxios from "vue-axios";
import "element-ui/lib/theme-chalk/index.css";
// 配置请求基础路径
// axios.defaults.baseURL = "http://msiot.com/api/";
axios.defaults.baseURL = "http://msiot.gzhcrobot.com/api/";
//配置post请求头
// axios.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencodedcharset=utf-8";
// // 发起请求之前处理
axios.interceptors.request.use((config) => {
  //
  if (config.method == "post" || config.method == "put") {
    config.headers['Content-Type']="application/json";
    // let paramsString = "";
    // //post请求参数序列化，转成一个字符串
    // for (let key in config.data) {
    //   paramsString += key + "=" + config.data[key] + "&";
    // }
    // config.data = paramsString.slice(0, -1);
  }
  // 把令牌添加到Authorization里面认证
  config.headers.Authorization = localStorage.getItem("meisutoken");
  return config;
});

// 引入mqtt组件
import mqtt from "mqtt";
Vue.prototype.$mqtt = mqtt;

Vue.use(VueAxios, axios);

Vue.config.productionTip = false;
// 引入路由组件
// import VueRouter from "vue-router";
// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err) => err);
// };

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
